module.exports = __webpack_public_path__ + "static/media/HuaweiLogo.722f1b26.webp";